"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGHFOrderDetailInfo = void 0;
const react_1 = require("react");
const useGHFOrderDetailInfo = (props) => {
    var _a;
    const { exchangeOrder, trend } = props;
    const subOrder = (_a = exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.exchangeGridV4FuturesHedgeGridOrder) === null || _a === void 0 ? void 0 : _a[trend];
    const newSubOrder = (0, react_1.useMemo)(() => {
        if (!subOrder)
            return undefined;
        const { gridProfit, totalProfit, unRealizedProfit, gridProfitPercent, totalProfitPercent, unrealizedProfitPercent, totalCost, isRunning, isConditionAndNotTriggered, state, msg, estimate_liquidation_price_up, estimate_liquidation_price_down, timestamp, closeTimestamp, } = subOrder;
        return {
            profit: gridProfit,
            totalProfit,
            unRealizedProfit,
            profitPercent: gridProfitPercent,
            totalProfitPercent,
            unRealizedProfitPercent: unrealizedProfitPercent,
            totalCost,
            low: subOrder.low,
            high: subOrder.high,
            number: subOrder.number,
            trx_24h: subOrder.trx_24h,
            trx_history: subOrder.trx_history,
            isRunning,
            isConditionAndNotTriggered,
            state,
            msg,
            estimate_liquidation_price_up,
            estimate_liquidation_price_down,
            timestamp,
            closeTimestamp,
            trendOrder: subOrder,
        };
    }, [subOrder]);
    return newSubOrder;
};
exports.useGHFOrderDetailInfo = useGHFOrderDetailInfo;
